import { useState } from 'react';
import { PanelLeftClose, PanelLeftOpen, Shapes } from 'lucide-react';
import { NODE_CATEGORIES, NODE_TYPES } from '../../lib/catalog';
import type { NodeKind } from '../../types';

// Painel lateral esquerdo: tipos de nó agrupados por categoria. Arraste para o canvas.
export function NodePalette() {
  const [collapsed, setCollapsed] = useState(false);

  function onDragStart(e: React.DragEvent, kind: NodeKind) {
    e.dataTransfer.setData('application/studio-node', kind);
    e.dataTransfer.effectAllowed = 'move';
  }

  if (collapsed) {
    return (
      <div className="flex w-12 shrink-0 flex-col items-center border-r border-line bg-white py-3">
        <button
          onClick={() => setCollapsed(false)}
          className="flex h-9 w-9 items-center justify-center rounded-lg text-slate hover:bg-cloud hover:text-ink"
          title="Expandir paleta de nós"
          aria-label="Expandir paleta de nós"
        >
          <PanelLeftOpen className="h-4 w-4" />
        </button>
        <div className="mt-2 flex h-9 w-9 items-center justify-center rounded-lg text-brand-orange">
          <Shapes className="h-4 w-4" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-60 shrink-0 flex-col border-r border-line bg-white">
      <div className="flex items-center justify-between border-b border-line px-4 py-3">
        <div>
          <h2 className="text-sm font-semibold text-ink">Paleta de nós</h2>
          <p className="text-xs text-slate">Arraste para o canvas</p>
        </div>
        <button
          onClick={() => setCollapsed(true)}
          className="rounded-lg p-1.5 text-slate hover:bg-cloud hover:text-ink"
          title="Colapsar paleta"
          aria-label="Colapsar paleta"
        >
          <PanelLeftClose className="h-4 w-4" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto scrollbar-thin p-3">
        {NODE_CATEGORIES.map((category) => (
          <div key={category} className="mb-4">
            <p className="mb-2 px-1 text-[11px] font-semibold uppercase tracking-wide text-slate">{category}</p>
            <div className="space-y-1.5">
              {NODE_TYPES.filter((n) => n.category === category).map((def) => (
                <div
                  key={def.kind}
                  draggable
                  onDragStart={(e) => onDragStart(e, def.kind)}
                  className="flex cursor-grab items-center gap-2.5 rounded-xl border border-line bg-white p-2 transition-colors hover:border-brand-orange/40 hover:bg-cloud active:cursor-grabbing"
                  title={def.description}
                >
                  <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-white" style={{ backgroundColor: def.color }}>
                    <def.icon className="h-4 w-4" />
                  </div>
                  <span className="text-sm font-medium text-ink">{def.label}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
